export function createOnceAsyncLock() {
  let locked = false;
  return {
    isLocked() {
      return locked;
    },
    async run(fn) {
      if (locked) return { ran: false };
      locked = true;
      try {
        return { ran: true, value: await fn() };
      } finally {
        locked = false;
      }
    },
  };
}
